import React from 'react';

import HistogramComponent from './Component';

const MIN_DOTS_PLOT_HEIGHT = 500;

class HistogramContainer extends React.PureComponent {

  state = {
    canvasWidth: 0,
    canvasHeight: 0
  }

  captureContainerProps = container => {
    if (container) {
      const canvasWidth = container.clientWidth;

      const canvasHeight =
        container.clientHeight >= MIN_DOTS_PLOT_HEIGHT
          ? container.clientHeight
          : MIN_DOTS_PLOT_HEIGHT;

      this.setState({ canvasWidth, canvasHeight });
    }
  }

  render () {
    return (
      <div ref={this.captureContainerProps} className="flex flex-grow">
        <div>
          {this.state.canvasWidth && this.state.canvasHeight &&
          <HistogramComponent {...this.props} {...this.state} />
          }
        </div>
      </div>
    );
  }
}

export default HistogramContainer;
